import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { Child } from '../../decorators/child.decorator';
import { Deprecated } from '../../decorators/deprecated.decorator';
import styles from './ui-awarddetails.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIAwardDetails
 * @element ui-awarddetails
 * @classdesc Represents a class for <code>ui-awarddetails</code> element.
 * Detailed view of award of offer or reward program in iBank.
 * @property {HTMLButtonElement} previousButton - Shortcut to previous button.
 * @property {HTMLButtonElement} nextButton - Shortcut to next button.
 * @example
 * <ui-awarddetails></ui-awarddetails>
 */
@Component({
    tag: 'ui-awarddetails',
    styles,
})
export class UIAwardDetails extends UIElement {
    @Deprecated('use previousButton property instead')
    @Child('button.-prev')
    prevBtn!: HTMLButtonElement;
    @Deprecated('use nextButton property instead')
    @Child('button.-next')
    nextBtn!: HTMLButtonElement;

    @Child('button.-next') previousButton!: HTMLButtonElement;
    @Child('button.-next') nextButton!: HTMLButtonElement;
}
